<template>
  <div class="navigatorRuleDatabaseClass">
  <NavbarComponent :loadingStatus="loading">Navigator Rule Database</NavbarComponent>
  <section class="ruledatabasesection">
  <div v-if="!loading" class="container is-fluid">
  
  
  <div class="datatable"><v-client-table :data="tableData" :columns="columns" :options="options">
  </v-client-table></div>

 </div>
 </section>
 
    
     
  </div>
</template>

<script>
import _ from 'lodash';
import NavbarComponent from '@/components/NavbarComponent.vue'



export default {
  name: 'NavigatorScriptDownloader',
  props: {
  },
  components: {NavbarComponent},
  data: function() {return {
    loading: false,
    message: '',
    scripts: [],
    scriptDownloadIdList: [],
    columns: ['identifier', 'script', 'name', 'description', 'expression', 'faultTriggerCondition', 'impact', 'actions', 'causes'],
        options: {
         filterByColumn: true,
      sortIcon: { //set sort icons
        base : 'fa',
        is: 'fa-sort',
        up:  'fa-sort-down',
        down:   'fa-sort-up'
      }
},
    }
  },
  computed: {
  tableData: function() {
    let table = [];
        this.scripts.forEach((script)=>{
        script.rules.forEach((rule)=>{
            let scriptName = this.scripts.find(script=> script.id === rule.scriptDefinitionId).name
            let scriptId = rule.scriptDefinitionId
            let scriptRule = scriptId + " " + scriptName
            let actions = "";
                rule.actions.forEach((action)=>{
                    actions += action.sequence + ". " + action.description + "\n";
                });
            let causes = "";
                    rule.causes.forEach((cause)=>{
                    causes += cause.sequence + ". " + cause.description + "\n";
                });
        
            table.push({identifier: rule.identifier,
            name: rule.name,
            description: rule.description,
            expression: rule.expression,
            faultTriggerCondition: rule.faultTriggerCondition,
            impact: rule.impact,
            actions: actions,
            causes: causes,
            script: scriptRule,
            })
            });
        });
    return table;    
  }
  
  },
  
  methods: {
  //convert unix time to date time
  convertunixtodatetime(timestamp){
  return moment.unix(parseInt(timestamp)/1000).format("DD/MM/YYYY HH:mm:ss Z");
  },
  

  AddAllScripts(){
    this.scriptDownloadIdList=this.scripts.map(script=>script.id);
  },
  ClearAllScripts(){
  this.scriptDownloadIdList=[];
  },
  
   strip(html)
{
   var tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
},
  
  getScripts(){
  this.loading=true;
  let url = this.$store.getters.proxyurl + "https://eadvantage.siemens.com/remote/release/analytics/scripts?userId="+this.$store.getters.navigatorUserId+"&adHocQueries=0&onlyWritableScripts=1&page=1&start=0&limit=-1&sort=translationName&dir=ASC";
  this.$axios(
    {method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
     }).then((response) => {
      this.scripts= _.orderBy(response.data,'id','asc');
      this.loading=false;
  
    }).catch((error) => {
    this.scripts = [];
      this.loading=false;
    });
  },
  
  
    async downloadScripts(){
  console.log("Downloading Scripts");
  this.loading=true;
  var workbook = new Excel.Workbook(); //create workbook
  let tempScriptDownloadIdList = this.scriptDownloadIdList;
console.log(tempScriptDownloadIdList);


  //for each script in the Id list to download
  for (var k = 0; k < tempScriptDownloadIdList.length; k++){
      let matchingScript = this.scripts.filter(script => {return script.id == tempScriptDownloadIdList[k]})[0] //filter through all scripts and get the matching id script
      console.log("Downloading Script");
      console.log(matchingScript.name);
      var sheet = workbook.addWorksheet(matchingScript.name); //add worksheet
      var worksheet = workbook.getWorksheet(matchingScript.name);
      worksheet.columns =[
      {header: 'Rule Name', width: 25},
        {header: 'Rule Description', width: 30},
          {header: 'Rule Id', width: 30},
            {header: 'Written By', width: 15},
              {header: 'Rule Status', width: 15},
                {header: 'Fault Trigger Conditions', width: 40},
                  {header: 'Node Tagging', width: 10},
                    {header: 'Rule Inputs', width: 25},
                      {header: 'Rule Parameters', width: 25},
                        {header: 'Rule Expression', width: 50},
                          {header: 'Impact', width: 50},
                     {header: 'Possible Causes', width: 50},
                          {header: 'Correction Action', width: 50},                      
        ];
       
       //Get all params urls for a script
       let ParamsPromiseArray = []
       for(var j = 0; j< matchingScript.rules.length; j++){
       let ruleparams = matchingScript.rules[j];
       let url = this.$store.getters.proxyurl + "https://eadvantage.siemens.com/remote/release/analytics/rules/" + ruleparams.id + "/usedparameters";
       ParamsPromiseArray.push(this.$axios.get(url, {headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}))
       }
       
       //get all params requests for a script  store in data array for iterating later
       let paramsDataArray = [] ;
       await this.$axios.all(ParamsPromiseArray).then((responseArray)=>{
       paramsDataArray = responseArray;
       }).catch((error) => {
       console.log(error);
        });
       
       
       for (var i = 0; i < matchingScript.rules.length; i++){
       var row = []
       let rule = matchingScript.rules[i];
       row.push(rule.name);
       row.push(rule.description);
       row.push(rule.identifier);
       row.push(''); //written by
       row.push(''); //rule status
          row.push(rule.faultTriggerCondition);
       row.push(''); //Node Tagging
       
       let rule_inputs = "";
       for (var m = 0; m < rule.dataPoints; m++){
       rule_inputs = rule_inputs + rule.dataPoints[m].pointName + '\n';
       }
        row.push(rule_inputs)
        
               //Rule Parameters
       let params_to_write="";
        paramsDataArray[i].data.forEach(param =>{ 
             params_to_write = params_to_write + param.name + "\n"
            });
            
          row.push(params_to_write);        
     
         row.push(rule.expression);
          row.push(rule.impact);
               

            let causes_to_write = "";
            rule.causes.forEach((cause,index) =>{
                causes_to_write = causes_to_write + (index+1).toString() + ". " + cause.description + "\n";
            });
            row.push(causes_to_write);    
       
              let actions_to_write = "";
            rule.actions.forEach((action,index) =>{
                actions_to_write = actions_to_write + (index+1).toString() + ". " + action.description + "\n";
            });
            row.push(causes_to_write);     
       
       
         worksheet.addRow(row);
       

       //set cells in range to wrapText is true 
       
       worksheet.eachRow(function(row, rowNumber){ //iterate through all non empty rows
            row.eachCell(function(cell, colNumber){ //iterate througha all non empty  cells
            cell.alignment = {vertical: 'top', wrapText: true};
            });
       });


}
  }

   //write workbook to file 

    workbook.xlsx.writeBuffer( {
                base64: true
            })
            .then( function (xls64) {
                // build anchor tag and attach file (works in chrome)
                var a = document.createElement("a");
                var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

                var url = URL.createObjectURL(data);
                a.href = url;
                a.download = "ScriptsDownload.xlsx";
                document.body.appendChild(a);
                a.click();
                setTimeout(function() {
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                    },
                    0);
            })
            .catch(function(error) {
                console.log(error.message);
            });
   
   
   
  this.loading=false;
 return console.log("Downloaded Scripts");

 
  

  },
  },
  mounted() {
  this.getScripts();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.ruledatabasesection{
margin-left:-30px;
margin-right:-30px;
padding-left:-30px;
padding-right:-30px;

}

.datatable{
  display: block;
  font-size: 0.7em;
  white-space: pre-wrap;
  overflow-y: hidden;
  overflow-x: auto;
  word-wrap:break-word;
}

.datatable input{
 font-size:1em;
}

.datatable table td:nth-child(5) {  
    max-width: 300px;
}

</style>
